module.exports = __webpack_public_path__ + "img/alpha-logo.230a6f75.png";